import { Controller } from '@hotwired/stimulus'
import Swiper from 'swiper/bundle'

export default class extends Controller {
  static targets = ['servicesCarousel']

  servicesCarouselTargetConnected(element) {
    new Swiper(element, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
      },
    })
  }
}
